import Api from '@/services/Api'

export default {
    getActivoCaracteristicaByActivo(activo){
        return Api().get('activoCaracteristica/activoCaracteristicaByActivo/'+activo)
    }
}